import { Spinner } from '@fluentui/react-components';
import { createRef, RefObject, SetStateAction } from 'react';
import { useFetchPlayerPlatformsQuery } from '../Api/Players/playersSlice';
import { Platform } from '../Media/Types';
import AddPlatformDialog from './AddPlatform';
import GameLibrary from './GameLibrary';

export interface PlayerPlatformsProps {
	username: string;
	isEditable: boolean;
	showModal: boolean;
	setShowModal: React.Dispatch<SetStateAction<boolean>>;
}

const PlayerPlatforms = (props: PlayerPlatformsProps) => {
	const { data: playerPlatforms, isLoading: platformsLoading } =
		useFetchPlayerPlatformsQuery(props.username);
	const platformRefs = [] as RefObject<HTMLDivElement | null>[];

	return (
		<div style={{ marginTop: '15px' }}>
			{!platformsLoading ? (
				playerPlatforms?.map((console, index: number) => {
					const platformRef = createRef<HTMLDivElement | null>();
					platformRefs.push(platformRef);
					return (
						<div
							key={`${console.name.replace(' ', '')}-${String(
								index
							)}-container`}
							ref={platformRef}
						>
							<GameLibrary
								key={`${console.name.replace(' ', '')}-${String(
									index
								)}`}
								username={props.username}
								console={new Platform(console.name)}
								isEditable={props.isEditable}
							/>
						</div>
					);
				})
			) : (
				<Spinner />
			)}
			<AddPlatformDialog
				isOpen={props.showModal}
				setIsOpen={props.setShowModal}
				playerPlatforms={playerPlatforms}
				platformRefs={platformRefs}
				username={props.username}
			/>
		</div>
	);
};

export default PlayerPlatforms;

export function PlayerPlatformActions() {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				paddingBottom: '3px'
			}}
		></div>
	);
}
